import React from "react";
import ForgotPasswordForm from "../../components/Authentication/ForgotPasswordForm";

const ForgotPassword = () => <ForgotPasswordForm />;

export default ForgotPassword;
